// Event names as const for type safety
export const AnalyticsEvents = {
  // Authentication
  SIGN_UP: 'sign_up',
  LOGIN: 'login',

  // Office Management
  OFFICE_CREATED: 'office_created',
  OFFICE_UPDATED: 'office_updated',
  OFFICE_DELETED: 'office_deleted',

  // Invitations
  INVITE_SENT: 'invite_sent',
  INVITE_ACCEPTED: 'invite_accepted',
  INVITE_REJECTED: 'invite_rejected',
  TEAM_INVITE_SENT: 'team_invite_sent',
  TEAM_INVITE_ACCEPTED: 'team_invite_accepted',

  // Bookings
  BOOKING_CREATED: 'booking_created',
  BOOKING_UPDATED: 'booking_updated',
  BOOKING_CANCELLED: 'booking_cancelled',

  // Desk Management
  DESK_CREATED: 'desk_created',
  DESK_UPDATED: 'desk_updated',
  DESK_DELETED: 'desk_deleted',

  // Team Management
  TEAM_MEMBER_ADDED: 'team_member_added',
  TEAM_MEMBER_REMOVED: 'team_member_removed',
  TEAM_BOOKINGS_VIEWED: 'team_bookings_viewed',

  // Profile
  PROFILE_UPDATED: 'profile_updated',

  // Admin
  ADMIN_STATISTICS_VIEWED: 'admin_statistics_viewed',
  ADMIN_USER_MANAGEMENT: 'admin_user_management',
  ADMIN_OFFICE_CONFIG: 'admin_office_config',

  // Page Views
  PAGE_VIEW: 'page_view'
} as const

export type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents]

// Event parameter interfaces
export interface AuthEventParams {
  method: 'email' | 'google' | 'other'
}

export interface OfficeEventParams {
  subscription_tier: 'free' | 'small' | 'medium' | 'large'
  is_manager: boolean
}

export interface BookingEventParams {
  is_proxy_booking: boolean
  recurrence_type: 'once off' | 'weekly'
  days_booked: number
}

export interface InvitationEventParams {
  invitation_type: 'office' | 'team'
}

export interface DeskEventParams {
  office_id: string
}

export interface ProfileEventParams {
  fields_updated: string[] // e.g., ['name', 'photo']
}

export interface AdminEventParams {
  action_type: string
}

export interface PageViewParams {
  page_path: string
  page_title: string
}
